export const REPORT_API_OPTIONS = {
	timeoutMessage:
		'El reporte está tardando más de lo normal en cargar. Pruebe con un rango de fechas más corto o aplique filtros, o espere unos minutos e intente de nuevo.',
};
